import React from 'react';

import { BrandCatalogContainer } from './styled';

export const BrandCatalog = () => {
  return (
    <BrandCatalogContainer>
      Brand Catalog content placeholder
    </BrandCatalogContainer>
  );
};
